var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    className: "design-iconfont",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9624 4.91113C10.2596 4.91113 10.5571 5.04038 10.7651 5.26855L16.0356 10.5361C16.2829 10.7938 16.3822 11.0615 16.3823 11.3291C16.3823 11.954 15.9463 12.4012 15.3521 12.4014C15.045 12.4014 14.7767 12.2824 14.5786 12.084L11.0425 8.64355V17.6484C11.0425 18.2933 10.6063 18.75 9.9624 18.75C9.32845 18.7499 8.88232 18.2932 8.88232 17.6484V8.57422L5.34619 12.084C5.15802 12.2822 4.89042 12.4013 4.5835 12.4014C3.9891 12.4014 3.54346 11.9541 3.54346 11.3291C3.54359 11.0614 3.65266 10.7936 3.88037 10.5557L9.15967 5.26855C9.37758 5.04041 9.66525 4.91117 9.9624 4.91113ZM17.812 1.25C18.3301 1.25 18.7505 1.67039 18.7505 2.18848C18.7503 2.70637 18.33 3.12598 17.812 3.12598H2.18799C1.66022 3.12584 1.23643 2.69066 1.25049 2.16309C1.26418 1.65512 1.67987 1.25013 2.18799 1.25H17.812Z",
    fill: "#0A6CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackTop);
export default __webpack_public_path__ + "static/media/back_top.d09e15077071d4907b0737d0d3698d34.svg";
export { ForwardRef as ReactComponent };